import {observer} from "mobx-react-lite";
import {SortableItem} from "./SortableItem";
import {stores} from "../../stores";
import React from "react";

export const SortableSelectorWrapper = observer(({presetNumber, itemKey, id, overed, srcElement, ctrlKeyPressed}) => {

    console.log("SortableSelectorWrapper", presetNumber)

    const presetOffset = stores.memory.getGlobalParamValue("PRESET_OFFSET");
    const displayNumber = presetNumber + presetOffset;

    return (
        <div className={`sortable-selector-wrapper`}>
        <div className="preset-number">{displayNumber}</div>
        <SortableItem
            presetNumber={presetNumber}
            key={itemKey}
            id={id}
            overed={overed}
            srcElement={srcElement}
            ctrlKeyPressed={ctrlKeyPressed} />
        </div>
    );

});
